import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-devicetablet",
  "use": "icon-th-devicetablet-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-devicetablet\">\n<path d=\"M24 3H8C7.20435 3 6.44129 3.31607 5.87868 3.87868C5.31607 4.44129 5 5.20435 5 6V26C5 26.7956 5.31607 27.5587 5.87868 28.1213C6.44129 28.6839 7.20435 29 8 29H24C24.7956 29 25.5587 28.6839 26.1213 28.1213C26.6839 27.5587 27 26.7956 27 26V6C27 5.20435 26.6839 4.44129 26.1213 3.87868C25.5587 3.31607 24.7956 3 24 3ZM7 9H25V23H7V9ZM8 5H24C24.2652 5 24.5196 5.10536 24.7071 5.29289C24.8946 5.48043 25 5.73478 25 6V7H7V6C7 5.73478 7.10536 5.48043 7.29289 5.29289C7.48043 5.10536 7.73478 5 8 5ZM24 27H8C7.73478 27 7.48043 26.8946 7.29289 26.7071C7.10536 26.5196 7 26.2652 7 26V25H25V26C25 26.2652 24.8946 26.5196 24.7071 26.7071C24.5196 26.8946 24.2652 27 24 27Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-devicetablet.svg
// module id = 1ReN
// module chunks = 84